module.exports = __webpack_public_path__ + "static/media/EMM-pennymac-dual-logo-300.9621e27f.svg";